export default ({ i18n }) => ({
  CURRENTLY_ASSIGNED_TEXT: i18n.t`Currently Assigned`,
  SELECT_CELL_TEXT: i18n.t`Select Cell`,
  UNSELECT_CELL_TEXT: i18n.t`Unselect Cell`,
  UNASSIGN_FROM_STUDENT_TEXT: i18n.t`Unassign from student`,
  REASSIGN_TEXT: i18n.t`Reassign`,
  ASSIGN_AND_REVIEW_TEXT: i18n.t`Assigned via Assign & Review`,
  LEARNING_GAPS_TEXT: i18n.t`Assigned via Learning Gaps`,
  VOLUNTARY_TEXT: i18n.t`Voluntarily attempted`,
  ATTEMPTS_TEXT: i18n.t`Attempts`,
  OVERDUE_ASSIGNMENT_REMOVED: i18n.t`StatusCell - Overdue assignment removed`
});
